import { render, staticRenderFns } from "./hidden_files_warning.vue?vue&type=template&id=77a18195&"
import script from "./hidden_files_warning.vue?vue&type=script&lang=js&"
export * from "./hidden_files_warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports